import styled from 'styled-components';

export const Style = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  overflow: hidden;

  .sidebar-area {
    position: relative;
    background-color: ${(props) => props.theme.colors.FL00};
  }

  .content-area {
    overflow: hidden;
    position: relative;
  }
`;

export const ResizeHandle = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 4px;
  height: 100%;
  cursor: col-resize;
  background-color: transparent;
  z-index: 10;

  &:hover,
  &.resizing {
    background-color: ${(props) => props.theme.colors.FL12};
  }
`;
